let LIVE_API_ADDRESS = 'https://api-dev.dev.dev-cglcloud.com/api/dxo/fibi';
let LIVE_API_ADDRESS_V1 = 'https://api-dev.dev.dev-cglcloud.com/api/dxo/fibi/v1';
let USER_SERVICE = 'https://api-dev.dev.dev-cglcloud.com/api/dxo/fibi/user-services/v1';
let PRICING_SERVICE = 'https://api-dev.dev.dev-cglcloud.com/api/dxo/fibi/commodity-pricing-service/v1';
let BULK_SERVICE = 'https://api-dev.dev.dev-cglcloud.com/api/dxo/v1';
let SALES_FORCE = 'https://api-dev.dev.dev-cglcloud.com/api/dxo/fibi/salesforce/v1';
let STRAPI_URL = 'https://api-dev.dev.dev-cglcloud.com/api/cfb-strapi/v1';
let MSW_URL = '';

if (window.__APP_CONFIG__ && window.__APP_CONFIG__.api) {
  LIVE_API_ADDRESS = window.__APP_CONFIG__.api.host + window.__APP_CONFIG__.api.path_v2;
  LIVE_API_ADDRESS_V1 = window.__APP_CONFIG__.api.host + window.__APP_CONFIG__.api.path;
  USER_SERVICE = window.__APP_CONFIG__.api.host + window.__APP_CONFIG__.api.userService;
  PRICING_SERVICE = window.__APP_CONFIG__.api.host + window.__APP_CONFIG__.api.pricingService;
  BULK_SERVICE = window.__APP_CONFIG__.api.host + window.__APP_CONFIG__.api.bulkService;
  SALES_FORCE = window.__APP_CONFIG__.api.host + window.__APP_CONFIG__.api.salesforce;
}

if (window.__APP_CONFIG__ && window.__APP_CONFIG__.strapiConfig) {
  STRAPI_URL = window.__APP_CONFIG__.strapiConfig.host + window.__APP_CONFIG__.strapiConfig.path;
}
if (window.__APP_CONFIG__ && window.__APP_CONFIG__.msw) {
  MSW_URL = window.__APP_CONFIG__.msw.host.replace('pstm_key', window.__APP_CONFIG__.msw.path);
}

const defaultValues = {
  retry: 0,
  interval: 0,
  timeout: 2000
};
const localConfig = {
  bulkUserNotification: {
    ...defaultValues,
    url: `${BULK_SERVICE}/notifications/{$}`,
    mockUrl: `${MSW_URL}/notifications/{$}`
  },
  downloadResultFile: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1.substring(0, LIVE_API_ADDRESS_V1.lastIndexOf('/'))}/`
  },
  dismissNotification: {
    ...defaultValues,
    url: `${BULK_SERVICE}/notifications/`,
    mockUrl: `${MSW_URL}/notifications/`
  },
  uploadBulkUserUrl: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/documents`,
    mockUrl: `${MSW_URL}/documents`
  },
  getSampleProductCategories: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/categories/sampleRequest`,
    mockUrl: `${MSW_URL}/v2/categories/sampleRequest`
  },
  getProductListing: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/sampleProducts`,
    mockUrl: `${MSW_URL}/v2/search/sampleProducts`
  },
  getGlobalNavProduct: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/categories`,
    mockUrl: `${MSW_URL}/v2/categories`
  },
  getBzUnits: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/bizUnits/{id}`,
    mockUrl: `${MSW_URL}/usersmgmt/bizUnits/{id}`
  },
  getProductDetail: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/products`,
    mockUrl: `${MSW_URL}/v2/search/products`
  },
  globalSearch: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search`,
    mockUrl: `${MSW_URL}/v2/search`
  },
  productSpecificDocument: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/documents`,
    mockUrl: `${MSW_URL}/v2/search/documents`
  },
  getDocument: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/documents`,
    mockUrl: `${MSW_URL}/v2/search/documents`
  },
  predictSearchResult: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/documents/suggest`,
    mockUrl: `${MSW_URL}/v2/search/documents/suggest`
  },
  getFavDocsId: {
    ...defaultValues,
    url: `${USER_SERVICE}/users/documents/favorite?type=`,
    mockUrl: `${MSW_URL}/users/documents/favorite?type=`
  },
  getUsers: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/list`,
    mockUrl: `${MSW_URL}/usersmgmt/list`
  },
  getUserData: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/{id}`,
    mockUrl: `${MSW_URL}/usersmgmt/{id}`
  },
  getAccountDetails: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/address/{id}`,
    mockUrl: `${MSW_URL}/usersmgmt/address/{id}`
  },
  getUserPermissions: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/permissions`,
    mockUrl: `${MSW_URL}/usersmgmt/permissions`
  },
  getPermissions: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/users/permissions`,
    mockUrl: `${MSW_URL}/users/permissions`
  },
  getVerifyEmail: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/verifyEmailId/{id}`,
    mockUrl: `${MSW_URL}/usersmgmt/verifyEmailId/{id}`
  },
  postUserInfo: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt`,
    mockUrl: `${MSW_URL}/usersmgmt`
  },
  userComment: {
    ...defaultValues,
    url: `${USER_SERVICE}/comments`,
    mockUrl: `${MSW_URL}/comments`
  },
  downloadUsersCSV: {
    ...defaultValues,
    url: `${USER_SERVICE}/groups/users?groupname=all`,
    mockUrl: `${MSW_URL}/groups/users?groupname=all`
  },
  getUserAccountList: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/account/list`,
    mockUrl: `${MSW_URL}/usersmgmt/account/list`
  },
  getTermsCondition: {
    ...defaultValues,
    url: `${USER_SERVICE}/users/{{emailId}}/termsandconditions`,
    mockUrl: `${MSW_URL}/users/{{emailId}}/termsandconditions`
  },
  termsCondition: {
    ...defaultValues,
    url: `${USER_SERVICE}/users/termsandconditions`,
    mockUrl: `${MSW_URL}/users/termsandconditions`
  },
  generalSupport: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/generalsupport`,
    mockUrl: `${MSW_URL}/generalsupport`
  },
  getDeactivateUser: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/{id}/deactivate`,
    mockUrl: `${MSW_URL}/usersmgmt/{id}/deactivate`
  },
  activateUser: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/{id}/activate`,
    mockUrl: `${MSW_URL}/usersmgmt/{id}/activate`
  },
  multiDocumentDownload: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/documents/attachment`,
    mockUrl: `${MSW_URL}/documents/attachment`
  },
  getCurrency: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/currency`,
    mockUrl: `${MSW_URL}/v2/cart/currency`
  },
  getCurrencyOdp: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/currency/odpCmdr`,
    mockUrl: `${MSW_URL}/v2/cart/currency/odpCmdr`
  },
  addToCart: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/addItems`,
    mockUrl: `${MSW_URL}/v2/cart/addItems`
  },
  getCart: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/fetch`,
    mockUrl: `${MSW_URL}/v2/cart/fetch`
  },
  validateCart: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/validate?encCartid=###`,
    mockUrl: `${MSW_URL}/v2/cart/validate?encCartid=###`
  },
  enableAddToCart: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/enableAddToCart`,
    mockUrl: `${MSW_URL}/v2/cart/enableAddToCart`
  },
  enableAddToCartOdp: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/enableAddToCart/odpCmdr`,
    mockUrl: `${MSW_URL}/v2/cart/enableAddToCart/odpCmdr`
  },
  clearCartAll: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/clear/all`,
    mockUrl: `${MSW_URL}/v2/cart/clear/all`
  },
  reOrder: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/reorder`,
    mockUrl: `${MSW_URL}/v2/cart/reorder`
  },
  reOrderOdp: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/reorder/odpCmdr`,
    mockUrl: `${MSW_URL}/v2/cart/reorder/odpCmdr`
  },
  getOrderListing: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v2/orders/list`,
    mockUrl: `${MSW_URL}/ordermgmt/v2/orders/list`
  },
  getOrderDetail: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v2/orders`,
    mockUrl: `${MSW_URL}/ordermgmt/v2/orders`
  },
  downloadReportUrl: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v2/orders/list/download`,
    mockUrl: `${MSW_URL}/ordermgmt/v2/orders/list/download`
  },
  getNotaFiscalDetails: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/notafiscal`,
    mockUrl: `${MSW_URL}/v2/search/notafiscal`
  },
  downloadInvoice: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/documents/invoice`,
    mockUrl: `${MSW_URL}/documents/invoice`
  },
  getUserDetails: {
    ...defaultValues,
    url: `${USER_SERVICE}/users/me`,
    mockUrl: `${MSW_URL}/users/me`
  },
  updateCart: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/update`,
    mockUrl: `${MSW_URL}/v2/cart/update`
  },
  simulateCart: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/simulate`,
    mockUrl: `${MSW_URL}/v2/cart/simulate`
  },
  placeOrder: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/submit`,
    mockUrl: `${MSW_URL}/v2/cart/submit`
  },
  deleteCart: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/delete`,
    mockUrl: `${MSW_URL}/v2/cart/delete`
  },
  removeItem: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/remove`,
    mockUrl: `${MSW_URL}/v2/cart/remove`
  },
  leadTime: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/leadtime?encCartid=`,
    mockUrl: `${MSW_URL}/v2/cart/leadtime?encCartid=`
  },
  getAccountsAndRegions: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/accounts`,
    mockUrl: `${MSW_URL}/usersmgmt/accounts`
  },
  requestCoa: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v2/orders/request/coa`,
    mockUrl: `${MSW_URL}/ordermgmt/v2/orders/request/coa`
  },
  orderInvoiceDownload: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v1/orders/invoice`,
    mockUrl: `${MSW_URL}/ordermgmt/v1/orders/invoice`
  },
  orderBoletoDownload: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v1/orders/boleto`,
    mockUrl: `${MSW_URL}/ordermgmt/v1/orders/boleto`
  },
  orderPackListDownload: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v1/orders/packlist`,
    mockUrl: `${MSW_URL}/ordermgmt/v1/orders/packlist`
  },
  orderProductCOADownload: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v1/orders/coa`,
    mockUrl: `${MSW_URL}/ordermgmt/v1/orders/coa`
  },
  orderProductBoletoDownload: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/ordermgmt/v1/orders/boleto`,
    mockUrl: `${MSW_URL}/ordermgmt/v1/orders/boleto`
  },
  deleteSession: {
    ...defaultValues,
    url: `${USER_SERVICE}/users/sessions`,
    mockUrl: `${MSW_URL}/users/sessions`
  },
  getContractListing: {
    url: `${LIVE_API_ADDRESS}/v2/contracts/list`,
    mockUrl: `${MSW_URL}/v2/contracts/list`,
    ...defaultValues
  },
  getContractDetail: {
    url: `${LIVE_API_ADDRESS_V1}/contracts/`,
    mockUrl: `${MSW_URL}/contracts/`,
    ...defaultValues
  },
  getContractPricing: {
    url: `${LIVE_API_ADDRESS}/v2/contracts/pricing/`,
    mockUrl: `${MSW_URL}/v2/contracts/pricing/`,
    ...defaultValues
  },
  getContractOrders: {
    url: `${LIVE_API_ADDRESS}/v2/contracts/orders/`,
    mockUrl: `${MSW_URL}/v2/contracts/orders/`,
    ...defaultValues
  },
  getContractListingV1: {
    url: `${LIVE_API_ADDRESS_V1}/contracts/list`,
    mockUrl: `${MSW_URL}/contracts/list`,
    ...defaultValues
  },
  deleteAccountRestriction: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/documents/entitlements`,
    mockUrl: `${MSW_URL}/documents/entitlements`
  },
  orderOptionUrl: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/orderoptions`,
    mockUrl: `${MSW_URL}/v2/cart/orderoptions`
  },
  orderOptionUrlOdp: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/orderoptions/odpCmdr`,
    mockUrl: `${MSW_URL}/v2/cart/orderoptions/odpCmdr`
  },
  fetchAllAvailableProducts: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/availableProducts`,
    mockUrl: `${MSW_URL}/v2/cart/availableProducts`
  },
  fetchAllAvailableProductsOdp: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/availableProducts/odpCmdr`,
    mockUrl: `${MSW_URL}/v2/cart/availableProducts/odpCmdr`
  },
  fetchAllAvailableMethods: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/shipmethod`,
    mockUrl: `${MSW_URL}/v2/cart/shipmethod`
  },
  fetchAllAvailableMethodsOdp: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/cart/shipmethod/odpCmdr`,
    mockUrl: `${MSW_URL}/v2/cart/shipmethod/odpCmdr`
  },
  getDocEntitlementAcccountsList: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/entitlements/accountlist`,
    mockUrl: `${MSW_URL}/v2/search/entitlements/accountlist`
  },
  downloadDocEntitlementAcccountsList: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/documents/entitlements/attachment`,
    mockUrl: `${MSW_URL}/documents/entitlements/attachment`
  },
  getAccountSoldTo: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/soldTos`,
    mockUrl: `${MSW_URL}/v2/search/soldTos`
  },
  getDocUnEntitlemendAcccountsList: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/globalAccounts/nonEntitled`,
    mockUrl: `${MSW_URL}/v2/search/globalAccounts/nonEntitled`
  },
  getDocEntitlementAcccountsDetails: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/documents/entitlements/entitlement-details`,
    mockUrl: `${MSW_URL}/documents/entitlements/entitlement-details`
  },
  postDocEntitlementAcccountsDetails: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/documents/entitlements`,
    mockUrl: `${MSW_URL}/documents/entitlements`
  },
  marketCommodityPrice: {
    ...defaultValues,
    url: `${PRICING_SERVICE}/commodities`,
    mockUrl: `${MSW_URL}/commodities`
  },
  getMarketNews: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/news`,
    mockUrl: `${MSW_URL}/news`
  },
  getCommodityChart: {
    ...defaultValues,
    url: `${PRICING_SERVICE}/commodities/history?code={$}&type=daily`,
    mockUrl: `${MSW_URL}/commodities/history?code={$}&type=daily`
  },
  updateUserPassword: {
    ...defaultValues,
    url: `${USER_SERVICE}/users/changepassword`,
    mockUrl: `${MSW_URL}/users/changepassword`
  },
  getSecurityQuestion: {
    ...defaultValues,
    url: `${USER_SERVICE}/users/factors/questions`,
    mockUrl: `${MSW_URL}/users/factors/questions`
  },
  securityQuestion: {
    ...defaultValues,
    url: `${USER_SERVICE}/users/securityquestion`,
    mockUrl: `${MSW_URL}/users/securityquestion`
  },
  postRequestSampleForm: {
    ...defaultValues,
    url: `${SALES_FORCE}/samples`,
    mockUrl: `${MSW_URL}/samples`
  },
  quoteRequest: {
    ...defaultValues,
    url: `${SALES_FORCE}/quotes`,
    mockUrl: `${MSW_URL}/quotes`
  },
  getUserContext: {
    ...defaultValues,
    url: `${BULK_SERVICE}/usersmgmt/context`,
    mockUrl: `${MSW_URL}/usersmgmt/context`
  },
  postTechDocRequest: {
    ...defaultValues,
    url: `${SALES_FORCE}/documents`,
    mockUrl: `${MSW_URL}/documents`
  },
  downloadDocuments: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/exportDocumentCSV/`,
    mockUrl: `${MSW_URL}/v2/search/exportDocumentCSV/`
  },
  getCategoryFromProducts: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/support`,
    mockUrl: `${MSW_URL}/v2/search/support`
  },
  reqASampleLeadTime: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/products/leadtime?sku=`,
    mockUrl: `${MSW_URL}/v2/products/leadtime?sku=`
  },
  downloadContract: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/contracts/download?`,
    mockUrl: `${MSW_URL}/v2/contracts/download?`
  },
  downloadContractLineDPO: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/downloadContractLineDPO`,
    mockUrl: `${MSW_URL}/v2/search/downloadContractLineDPO`
  },
  getSalesAreas: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/contractLineDPO/salesarea`,
    mockUrl: `${MSW_URL}/v2/search/contractLineDPO/salesarea`
  },
  downloadContractLineDPOodp: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS}/v2/search/downloadContractLineDPO/odpCmdr`,
    mockUrl: `${MSW_URL}/v2/search/downloadContractLineDPO/odpCmdr`
  },
  notificationPreferences: {
    ...defaultValues,
    url: `${LIVE_API_ADDRESS_V1}/users/notification-preferences`,
    mockUrl: `${MSW_URL}/users/notification-preferences`
  },
  getWebNotifications: {
    ...defaultValues,
    url: `${BULK_SERVICE}/notifications/global`,
    mockUrl: `${MSW_URL}/notifications/global`
  },
  postWebNotifications: {
    ...defaultValues,
    url: `${BULK_SERVICE}/notifications/`,
    mockUrl: `${MSW_URL}/notifications/`
  },
  getMyRequests: {
    ...defaultValues,
    url: `${SALES_FORCE}/myrequests`,
    mockUrl: `${MSW_URL}/myrequests`
  },
  getSampleSizeList: {
    ...defaultValues,
    url: `${SALES_FORCE}/sampleSize`,
    mockUrl: `${MSW_URL}/sampleSize`
  },
  getBanner: {
    ...defaultValues,
    url: `${STRAPI_URL}/banners`,
    mockUrl: `${MSW_URL}/banners`
  }
};

const config = localConfig;
export default config;
